import { render } from "./signup.vue?vue&type=template&id=7a458f39"
import script from "./signup.vue?vue&type=script&lang=js"
export * from "./signup.vue?vue&type=script&lang=js"
script.render = render

export default script